// Card styles copied from Risk Management so the public page matches the app.
export const PAGE_MAX_WIDTH = 1280;

export const styles = {
  // body has overflow-y: hidden app-wide, so the page scrolls itself.
  page: {
    height: "100vh",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: "#F9FAFB",
  },
  pageInner: {
    maxWidth: PAGE_MAX_WIDTH,
    width: "100%",
    mx: "auto",
    px: { xs: 2, sm: 3, lg: 4 },
    py: 3,
    boxSizing: "border-box",
  },
  statsCard: {
    p: 2,
    borderRadius: "12px",
    border: "1px solid #E8EAED",
    backgroundColor: "#FFFFFF",
    flex: 1,
    // As Risk's stat cards: no minimum width, so three always fit side by
    // side (a 180px minimum plus padding pushed the last one off the page).
    minWidth: 0,
    boxSizing: "border-box",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      transform: "translateY(-2px)",
    },
  },
  logoFrame: {
    width: 120,
    height: 64,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    border: "1px dashed #C5C9CF",
    backgroundColor: "#FAFBFC",
    overflow: "hidden",
  },
  // Grid cells already stretch tiles to equal height; height: 100% plus
  // padding made them spill into the next row.
  detailTile: {
    p: 1.75,
    boxSizing: "border-box",
    borderRadius: "12px",
    border: "1px solid #E8EAED",
    backgroundColor: "#F9FAFB",
  },
  mainCard: {
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    border: "1px solid #E8EAED",
    scrollMarginTop: "88px",
  },
  cardHeader: {
    flexWrap: "wrap",
    rowGap: 1.5,
    borderBottom: "1px solid #ddd",
    background: "#F7F7FC",
    ".MuiCardHeader-title": {
      fontSize: "16px",
      fontWeight: "bold",
    },
    ".MuiCardHeader-subheader": {
      fontSize: "13px",
    },
    // On phones the header action (search, unlock) drops below the title.
    ".MuiCardHeader-content": {
      minWidth: { xs: "100%", sm: 0 },
    },
    ".MuiCardHeader-action": {
      m: 0,
      alignSelf: "center",
      width: { xs: "100%", sm: "auto" },
    },
  },
  // Same dashed n/total box as People "Policies Accepted".
  countBox: {
    display: "inline-flex",
    alignItems: "center",
    px: 1,
    py: 0.25,
    border: "1px dashed #C5C9CF",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 600,
    color: "#374151",
    whiteSpace: "nowrap",
  },
};
